/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['app-root{display:block;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}app-root.loading{opacity:.7}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvYXBwLmNvbXBvbmVudC5zY3NzLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9tbnQvZS9hcHBzL2hlbHBkZXNrL2NsaWVudC9zcmMvYXBwL2FwcC5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/app.component.scss.ngstyle.ts